import {
  GET_VEHICLE_VIDEO_LIST,
  SET_VIDEO_STREAM_STATUS,
  SET_VIDEO_STREAM_STATUS_OFF,
} from '@/services/api/trackvideo/video'
import { client } from '@/services/apolloclient'
import Vue from 'vue'
import { v4 as uuidv4 } from 'uuid'
import { Helper } from '@/mixin/helper'
import apiClient from '@/services/rest-api-tools/apiClient'

export const state = {
  isWsConnected: false,
  fleets: [],
  tempVehicleStatuses: {},
  vehicleStatuses: {},
  loadingFleets: true,
  fleetSelection: [],
  fleetClose: {},
  fleetOpen: {},
  cameraProps: {},
  isVideoProps: {},
  isInVideoProps: {},
  isVideoFullscreenProps: {
    isLoading: false,
    isVideoError: false,
    isVideoStopped: false,
    isPlay: true,
    isMuted: false,
    isRequestOnlineCommand: false,
    onLoadingTimeout: null,
    retry: 0,
  },
  checkedVehicles: {},

  playlist: [],
  maxVideo: 16,
  gridNumber: 9,

  voipVehicleIdActives: [],
  voipState: {},
  fleetListDisplay: {},
}

export const getters = {
  fleetsListFilter: (state) => (search) => {
    if (!search) {
      return state.fleets || [];
    }
  
    search = search.trim().toLowerCase();
  
    return state.fleets.filter(
      (fleet) =>
        search == fleet.vehicle.licensePlate.trim().toLowerCase() ||
        search == fleet.vehicle.driver1?.fullname.trim().toLowerCase()
    );
  },
  fleetsList: (state) => state.fleets || [],
  vehicleStatusByVehicleId: (state) => (vehicleId) => {
    return state.vehicleStatuses[vehicleId]
  },
  tempVehicleStatusByVehicleId: (state) => (vehicleId) => {
    return state.tempVehicleStatuses[vehicleId]
  },
  
  flespiHowenVehicleIds: (state) => {
    return state.fleets
      .filter(
        (fleet) => Helper.methods.getDeviceType(fleet.vehicle.device.deviceCode) === 'flespi-howen'
      )
      .map((fleet) => fleet.vehicleId)
  },
}

export const actions = {
  async getTotalCamera({ commit }) {
    let device = JSON.parse(localStorage.getItem('device'))
    let motionStatus = "" 
    
    switch(device.vehicle.vehicle_status.vehicle_motion_status){
    case "Diam":
      motionStatus = "I"
      break;
    case "Bergerak":
      motionStatus = "M"
      break;
    case "Offline":
      motionStatus = "O"
      break;
    default:
      motionStatus = "P"
      break;
    }

    let res = {
      vehicleId: device.vehicle.vehicle_id,
      motionStatus: motionStatus,
      calculatedMotionStatus: motionStatus,
    }
    res.vehicle = {
      id: device.vehicle.vehicle_id,
      licensePlate: device.vehicle.license_plate,
      imei: device.imei,
      device: {
        phoneNo: device.phoneNo,
        deviceCode: device.deviceCode,
        deviceName: device.deviceType.deviceName,
      }
    }

    const maxCamera = await apiClient({
      method: 'GET',
      url: `/device/max-camera?device_code=${device.deviceCode}`        
    }).then((response) => {
      return response.data
    })

    const indexStart = maxCamera.index_start

    await apiClient({
      method: 'GET',
      url: `/device/get-total-camera?vehicle_id=${device.vehicle.vehicle_id}`,
    }).then((response) => {
      res.statusText = response.data.camera
      var vehicles = [
        res,
      ]

      vehicles.forEach(function (item) {
        item.checked = false
        item.playlist = []
        item.channel = []
        if (item.statusText) {
          let moveRow = !indexStart ? 1 : 0
          item.startFromZero = !indexStart ? true : false
          item.statusText.split(',').forEach((row) => {
            item.channel.push({ text: Number(row) + moveRow, value: `${item.vehicleId}:${row}`, play: 0 })
          })
        }
      })

      commit('setFleets', vehicles)
    })
  },

  async requestFleets({ commit }, payload) {
    await client
      .query({
        query: GET_VEHICLE_VIDEO_LIST,
        variables: payload.filter,
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (response.data.vehicleVideoTrackers.isSuccessful) {
          var vehicles = response.data.vehicleVideoTrackers.vehicleVideoTrackers
          vehicles.forEach(function (item) {
            item.checked = false
            item.playlist = []
            item.channel = []
            item.vehicle.device.deviceType = Helper.methods.getDeviceType(
              item.vehicle.device.deviceCode
            )
            if (item.statusText) {
              item.statusText.split(',').forEach((row, index) => {
                item.channel.push({ text: index + 1, value: `${item.vehicleId}:${row}`, play: 0 })
              })
            }
          })

          commit('setFleets', vehicles)
        }
      })
  },

  // eslint-disable-next-line no-unused-vars
  async setVideoStreamStatus({ commit, dispatch }, payload) {
    let promises = []

    const deviceType = Helper.methods.getDeviceType(payload.vehicle.device.deviceCode)

    const isJc = deviceType === 'jc'

    // Start stream
    const _channels = [] // '1', '2', '3'
    payload.playlist.forEach((row) => {
      const arr = row.split(':')
      _channels.push(isJc ? (parseInt(arr[1]) + 1).toString() : arr[1])
    })

    if (_channels.length) {
      promises.push(
        dispatch('requestOnlineCommandStreamStatus', {
          channels: _channels,
          imei: payload.vehicle.imei,
          status: true,
          statsDataV2: {
            inputDataRequest: _channels.map((channel, index) => ({
              channel,
              id: payload.playlistWithUid[index].uid,
            })),
          },
        })
      )
    }

    return await Promise.all(promises).then((response) => {
      const channelSent =
        response[response.length - 1]?.data.setVideoStreamStatus.setVideoStreamStatus.channelSent
      const channelNotSent =
        response[response.length - 1]?.data.setVideoStreamStatus.setVideoStreamStatus.channelNotSent
      return { channelSent, channelNotSent }
    })
  },

  async requestOnlineCommandStreamStatus(_, payload) {
    try {
      const response = await client.mutate({
        mutation: SET_VIDEO_STREAM_STATUS,
        variables: {
          input: {
            ...payload,
          },
        },
      })
      return response
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  },

  async setVideoStreamStatusPerVideo(_, { imei, channel, status, statsData, statsDataV2 }) {
    await client.mutate({
      mutation: SET_VIDEO_STREAM_STATUS,
      variables: {
        input: {
          channels: [channel],
          imei,
          status,
          ...(statsData ? { statsData } : {}),
          ...(statsDataV2 ? { statsDataV2 } : {}),
        },
      },
    })
  },

  async setVideoStreamStatusOff() {
    await client.mutate({
      mutation: SET_VIDEO_STREAM_STATUS_OFF,
    })
  },
}

export const mutations = {
  ORDER_BY(state, payload) {
    if (payload.objName == 'licensePlate') {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort((a, b) =>
          a.vehicle[payload.objName] > b.vehicle[payload.objName]
            ? 1
            : b.vehicle[payload.objName] > a.vehicle[payload.objName]
            ? -1
            : 0
        )
      } else {
        state.fleets = state.fleets.sort((a, b) =>
          b.vehicle[payload.objName] > a.vehicle[payload.objName]
            ? 1
            : a.vehicle[payload.objName] > b.vehicle[payload.objName]
            ? -1
            : 0
        )
      }
    } else {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort((a, b) =>
          a[payload.objName] > b[payload.objName]
            ? 1
            : b[payload.objName] > a[payload.objName]
            ? -1
            : 0
        )
      } else {
        state.fleets = state.fleets.sort((a, b) =>
          b[payload.objName] > a[payload.objName]
            ? 1
            : a[payload.objName] > b[payload.objName]
            ? -1
            : 0
        )
      }
    }
  },
  setFleets(state, payload) {
    state.fleets = payload
  },
  setIsWsConnected(state, payload) {
    state.isWsConnected = payload
  },
  setVehicleStatuses(state, payload) {
    state.vehicleStatuses = payload
  },
  setTempVehicleStatusesByVehicleId(state, { vehicleId, data }) {
    state.tempVehicleStatuses[vehicleId] = data
  },
  setVehicleStatusesByVehicleId(state, { vehicleId, data }) {
    state.vehicleStatuses[vehicleId] = data
  },
  resetTempVehicleStatuses(state) {
    state.tempVehicleStatuses = {}
  },
  selectFleet(state, payload) {
    if (state.fleetSelection.includes(payload)) return

    if (state.fleetSelection.length >= 3) {
      Vue.set(state.isVideoProps, `video${payload.vehicleId}`, undefined)
      Vue.set(state.isInVideoProps, `video${payload.vehicleId}`, undefined)
      Vue.set(state.cameraProps, `video${payload.vehicleId}`, undefined)

      state.fleetClose = state.fleetSelection[0]
      state.fleetSelection.splice(0, 1)
    }

    const domainStart = ((state.fleetSelection.length * 2) % 3) + 1

    const arrDomain = (() => {
      if (domainStart === 1 || domainStart === 2) {
        return [domainStart, domainStart + 1]
      }
      if (domainStart === 3) {
        return [domainStart, 1]
      }
    })()

    const urlInside = `${process.env.VUE_APP_RTMP_URL.replace('{domain}', arrDomain[1])}/live/1/${
          payload.vehicle.imei
        }.m3u8`
    const urlOutside = `${process.env.VUE_APP_RTMP_URL.replace('{domain}', arrDomain[0])}/live/0/${
          payload.vehicle.imei
        }.m3u8`

    Vue.set(state.isVideoProps, `video${payload.vehicleId}`, {
      isLoading: false,
      isVideoError: false,
      isVideoStopped: false,
      isPlay: true,
      isMuted: false,
      onLoadingTimeout: null,
      src: urlOutside,
      retry: 0,
    })
    Vue.set(state.isInVideoProps, `video${payload.vehicleId}`, {
      isLoading: false,
      isVideoError: false,
      isVideoStopped: false,
      isPlay: true,
      isMuted: false,
      onLoadingTimeout: null,
      src: urlInside,

      retry: 0,
    })
    Vue.set(state.cameraProps, `video${payload.vehicleId}`, 'INOUT')

    payload.channel = payload.channel.map((channel) => ({
      ...channel,
      uid: uuidv4(),
    }))

    state.fleetOpen = payload
    state.fleetSelection.push(payload)
  },
  loadingFleets(state, payload) {
    state.loadingFleets = payload
  },
  removeFleet(state, payload) {
    state.fleetOpen = null

    if (state.checkedVehicles[payload.vehicleId]) {
      state.checkedVehicles[payload.vehicleId] = false
    }

    Vue.set(state.isVideoProps, `video${payload.vehicleId}`, undefined)
    Vue.set(state.isInVideoProps, `video${payload.vehicleId}`, undefined)
    Vue.set(state.cameraProps, `video${payload.vehicleId}`, undefined)

    const indexToRemove = state.fleetSelection.findIndex(
      (fleet) => fleet.vehicleId === payload.vehicleId
    )

    if (indexToRemove !== -1) {
      state.fleetSelection.splice(indexToRemove, 1)
    }
  },
  clearFleet(state) {
    state.fleetOpen = null

    Vue.set(state, `isVideoProps`, {})
    Vue.set(state, `isInVideoProps`, {})
    Vue.set(state, `cameraProps`, {})
    Vue.set(state, `fleetSelection`, [])
  },
  setVideoError(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isVideoError = payload.error
  },
  setInVideoError(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isVideoError = payload.error
  },
  setVideoStopped(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isVideoStopped = payload.isStop
  },
  setInVideoStopped(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isVideoStopped = payload.isStop
  },
  setPlay(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isPlay = payload.isPlay
  },
  setInPlay(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isPlay = payload.isPlay
  },
  setMuted(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isMuted = payload.isMuted
  },
  setInMuted(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isMuted = payload.isMuted
  },
  setRetry(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].retry = payload.retry
  },
  setInRetry(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].retry = payload.retry
  },
  setLoading(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isLoading = payload.isLoading
  },
  setInLoading(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isLoading = payload.isLoading
  },
  setRequestOnlineCommand(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].isRequestOnlineCommand =
      payload.isRequestOnlineCommand
  },
  setInRequestOnlineCommand(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].isRequestOnlineCommand =
      payload.isRequestOnlineCommand
  },
  setInSrc(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].src = payload.src
  },

  setCamera(state, payload) {
    state.cameraProps[`video${payload.vehicleId}`] = payload.camera
  },

  setVideoFullscreenProp(state, payload) {
    state.isVideoFullscreenProps[payload.props] = payload.state
  },

  setOnLoadingState(state, payload) {
    state.isVideoProps[`video${payload.vehicleId}`].onLoadingTimeout = payload.state
  },
  setInOnLoadingState(state, payload) {
    state.isInVideoProps[`video${payload.vehicleId}`].onLoadingTimeout = payload.state
  },

  setGridNumber(state, payload) {
    state.gridNumber = payload
  },

  addVoipVehicleIdActive(state, vehicleId) {
    state.voipVehicleIdActives = [...state.voipVehicleIdActives, vehicleId]
  },

  removeVoipVehicleIdActive(state, vehicleId) {
    const temp = state.voipVehicleIdActives.filter((id) => id !== vehicleId)
    state.voipVehicleIdActives = temp
  },

  resetVoipVehicleIdActive(state) {
    state.voipVehicleIdActives = []
  },

  setVoipState(state, { vehicleId, values }) {
    const tempState = Object.assign({}, state.voipState)
    tempState[vehicleId] = values
    state.voipState = tempState
  },

  deleteVoipState(state, vehicleId) {
    const tempState = Object.assign({}, state.voipState)
    delete tempState[vehicleId]
    state.voipState = tempState
  },

  resetVoipState(state) {
    state.voipState = {}
  },

  setPlaylist(state, payload) {
    let tempPlaylist = [...state.playlist]

    const deviceType = Helper.methods.getDeviceType(payload.vehicle.device.deviceCode)

    const removeAll = tempPlaylist.filter((x) => x.vehicleId != payload.vehicleId)
    tempPlaylist = [...removeAll]

    const remain = payload.playlist.length + tempPlaylist.length - state.maxVideo
    if (remain) tempPlaylist.slice(remain)
    else tempPlaylist.slice(payload.playlist.length)

    const getRtmpUrl = (type, imei, channel, domain) => {
      if (type === 'bsj')
        return `${process.env.VUE_APP_RTMP_URL.replace(
          '{domain}',
          domain
        )}/live/stream/${imei}-${channel}.flv`
      if (type === 'jc')
        return `${process.env.VUE_APP_RTMP_URL.replace(
          '{domain}',
          domain
        )}/live/${channel}/${imei}.flv`
      if (type === 'flespi-howen') return null
    }

    payload.playlist.forEach((row, index) => {
      if (row != tempPlaylist[index]?.id) {
        const arr = row.split(':')
        const camera = payload.channel.findIndex((x) => x.value == row)
        tempPlaylist.push({
          id: row,
          vehicleId: arr[0],
          channel: arr[1],
          camera: camera + 1,
          licensePlate: payload.vehicle.licensePlate,
          calculatedMotionStatus: payload.calculatedMotionStatus,
          deviceType,
          uid: payload.playlistWithUid.find((data) => data.playlist === row).uid,
        })
      } else {
        tempPlaylist[index] = null
      }
    })

    tempPlaylist = tempPlaylist.map((data, index) => {
      const arr = data.id.split(':')
      const domain = (index % 3) + 1
      const fleet = state.fleets.find((fleet) => fleet.vehicleId == data.vehicleId)
      const imei = fleet?.vehicle.imei
      return {
        ...data,
        src: getRtmpUrl(deviceType, imei, arr[1], domain),
      }
    })

    state.playlist = [...tempPlaylist]
  },

  resetPlaylist(state) {
    state.playlist = []
  },

  setFleetListDisplay(state, payload) {
    state.fleetListDisplay = payload
  },
}
